import Layout from 'components/Layout'
import Loader from 'components/Loader'
import RevenueCentersForm from 'components/RevenueCenters/Form'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { loadGlobalItems } from 'store/Items/actions'
import { getIsItemsLoading } from 'store/Items/selector'
import {
  getMenusForRevenueCenterWithCurrentCreatedMenus,
  getRevenueCenter,
} from 'store/RevenueCenters/selector'
import {
  getServiceTypeSucceeded,
  loadRevenueCenters,
} from 'store/RevenueCenters/actions'
import { getIsServiceTypeLoading } from 'store/RevenueCenters/selector'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import { getIsMenusLoading } from 'store/Menus/selectors'
import { getIsMerchantsLoading } from 'store/Merchants/selectors'
import { fetchMerchants } from 'store/Merchants/actions'
import { loadMenus } from 'store/Menus/actions'
import useEmailAuth from 'hooks/useEmailAuth'

const RevenueCentersDetailsPage = () => {
  const dispatch = useDispatch()
  const { revenueCenterId } = useParams()

  const isVenueNexter = useEmailAuth()

  const currentVenueUuid = useSelector(getCurrentVenueUuid)
  const currentRevenueCenter = useSelector((state) =>
    getRevenueCenter(state, revenueCenterId)
  )
  const menusForCurrentRevenueCenter = useSelector((state) =>
    getMenusForRevenueCenterWithCurrentCreatedMenus(
      state,
      currentRevenueCenter.id
    )
  )
  const isServiceTypesLoading = useSelector(getIsServiceTypeLoading)
  const isItemsLoading = useSelector(getIsItemsLoading)
  const isLoadingMenus = useSelector(getIsMenusLoading)
  const isMerchantsLoading = useSelector(getIsMerchantsLoading)

  const isLoading =
    isServiceTypesLoading ||
    isItemsLoading ||
    isLoadingMenus ||
    isMerchantsLoading

  // Here I take all menus assigned to current revenue center and dispatch them to the store ServiceTypes due to catch array of menus,
  // to add or remove them and then dispatch this array with all Revenue Center form. After dispatching I clear this store.

  useEffect(() => {
    dispatch(getServiceTypeSucceeded(menusForCurrentRevenueCenter))
    dispatch(loadMenus(currentVenueUuid, isVenueNexter))
    dispatch(loadGlobalItems(currentVenueUuid))
    dispatch(loadRevenueCenters(currentVenueUuid, isVenueNexter))
    dispatch(fetchMerchants(currentVenueUuid))
  }, [])

  if (isLoading) {
    return <Loader />
  }

  return (
    <Layout
      isSidebar
      mainContent={isLoading ? <Loader /> : <RevenueCentersForm />}
    />
  )
}

export default RevenueCentersDetailsPage
